import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// project import
import { complianceRoutes } from './global/compliance/compliance.routes';
import { configRoutes } from './global/configuration/config.routes';
import { currencyRoutes } from './global/currency/currency.routes';
import { customerRoutes } from './global/customer/customer.routes';
import { dashRoutes } from './global/dashboard/dashboard.routes';
import { discountRoutes } from './global/discount/discount.routes';
import { entityRoutes } from './global/entity/entity.routes';
import { posRoutes } from './global/pos/pos.routes';
import { pricePromotionRoutes } from './global/price-promotion/price-promotion.routes';
import { purchaseReqRoutes } from './global/procurement/purchase-request.routes';
import { productRoutes } from './global/product/product.routes';
import { taxRoutes } from './global/taxation/taxation.routes';
import { userSecRoutes } from './global/user-security/user-security.routes';
import { vendorRoutes } from './global/vendor/vendor.routes';
import { authGuard } from './guards/auth/auth-guard';
import { Layout } from './layout/layout';

const routes: Routes = [
  { path: 'maintenance', loadComponent: () => import('./error-page/maintenance/maintenance').then((m) => m.Maintenance) },
  {
    path: 'permission-denied',
    loadComponent: () => import('./error-page/permission-denied/permission-denied').then((m) => m.PermissionDenied),
    data: { moduleCode: 'permission-denied' }
  },
  {
    path: 'page-not-found',
    loadComponent: () => import('./error-page/page-not-found/page-not-found').then((m) => m.PageNotFound),
    data: { moduleCode: 'page-not-found' }
  },
  {
    path: '',
    loadComponent: () => import('./global/authentication/auth/auth').then((m) => m.Auth),
    canActivateChild: [authGuard],
    children: [
      {
        path: 'login',
        loadComponent: () => import('./global/authentication/auth-login/auth-login').then((m) => m.AuthLogin),
        data: { moduleCode: 'login' }
      },
      {
        path: 'register',
        loadComponent: () => import('./global/authentication/auth-register/auth-register').then((m) => m.AuthRegister),
        data: { moduleCode: 'register' }
      },
      { path: '', redirectTo: 'login', pathMatch: 'full' }
    ]
  },
  {
    path: '',
    component: Layout,
    canActivateChild: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      //Sub-Navigation
      {
        path: 'sub-navigation/:moduleKey',
        loadComponent: () => import('./layout/navigation/sub-navigation/sub-navigation').then((m) => m.SubNavigation)
      },
      {
        path: 'search',
        loadComponent: () => import('./layout/navigation/sub-navigation/sub-navigation').then((m) => m.SubNavigation),
        data: { moduleCode: 'global-search' }
      },
      //Account Settings
      {
        path: 'account-settings',
        loadComponent: () => import('./global/account-settings/account-settings').then((m) => m.AccountSettings),
        data: { moduleCode: 'acc_settings' }
      },
      //Notifications
      {
        path: 'notifications',
        loadComponent: () => import('./global/notifications/notifications').then((m) => m.Notifications),
        data: { moduleCode: 'noti' }
      },

      ...dashRoutes,
      ...userSecRoutes,
      ...entityRoutes,
      ...configRoutes,
      ...complianceRoutes,
      ...productRoutes,
      ...customerRoutes,
      ...vendorRoutes,
      ...discountRoutes,
      ...posRoutes,
      ...pricePromotionRoutes,
      ...currencyRoutes,
      ...taxRoutes,
      ...purchaseReqRoutes

      //   {
      //     path: 'orgchart',
      //     loadComponent: () => import('./admin-hub/features/org-chart/org-chart').then((c) => c.OrgChart)
      //   },
      //   {
      //     path: 'bubble-map',
      //     loadComponent: () => import('./poc/modules/bubble-map/bubble-map').then((c) => c.BubbleMap)
      //   }
    ]
  },
  { path: '**', redirectTo: 'page-not-found' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
